/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ModuleAccessIncludeFilterItems } from './moduleAccessIncludeFilterItems';
import { ModuleAccessScopeFilter } from './moduleAccessScopeFilter';


export interface ModuleAccessIncludeFilterInner { 
    relation?: ModuleAccessIncludeFilterInner.RelationEnum;
    scope?: ModuleAccessScopeFilter;
}
export namespace ModuleAccessIncludeFilterInner {
    export type RelationEnum = 'user' | 'company' | 'modulePermission';
    export const RelationEnum = {
        User: 'user' as RelationEnum,
        Company: 'company' as RelationEnum,
        ModulePermission: 'modulePermission' as RelationEnum
    };
}


